<template>
  <div class ="sales-chart__chart-container">
    <h3>TIER MIX</h3>
    <ChartLoader v-if="loading"></ChartLoader>
    <div class="css-grid sales-chart__chart-wrapper" v-else>
      <div class="sales-chart__chart-legend">
        <table class="pieTable">
          <tr>
              <th class="pieTable__header pieTable__header--key" colspan="2">Tier</th>
              <th class="pieTable__header pieTable__header--value">Units Sold</th>
          </tr>
          <tbody v-if="mixTierData">
          <tr v-bind:key="index" v-for="(units, tier, index) in formattedData">
              <td class="chartColor"><div class="chartColor__box" v-bind:class="`chartColor__box--${ucFirst(tier)}`">&nbsp;</div></td>
              <td class="pieTable__key">{{ ucFirst(tier) }}</td>
              <td class="pieTable__value">{{ currency(units) }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="sales-chart__chart h-center-align">
        <ChartCustom :chart-settings="chartConfig" :allow-resize="false" :dimensions="chartConfig.size" class="chart__mix"></ChartCustom>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import ChartCustom from '../../general/ChartCustom.vue'
  import ChartLoader from '../../general/ChartLoader.vue'
  import DataMethods from '../../utils/DataMethods';

  export default {
    name: 'ChartMixTier',
    mixins: [DataMethods],
    components: {
      ChartCustom,
      ChartLoader,
    },
    props: {
      entityData: {
        type: Object,
      },
      filters: {
        type: String,
      },
    },
    data() {
      return {
        mixTierData: [],
        loading: false,
      };
    },
    mounted() {
      this.loading = true;
      axios.get(`/api/sales/hearing-aids/member/mixTier/?${this.filters}`, { cancelToken: this.cancelToken.token })
        .then((response) => {
          this.mixTierData = lodash.sortBy(response.data, (tier) => parseInt(tier.units, 10)).reverse();
          this.loading = false;
        }).catch((thrown) => {});
    },
    computed: {
      ...mapGetters('purchaseActivity', ['cancelToken']),
      chartConfig() {
        return {
          size: { width: 150, height: 150 },
          data: {
            json: this.formattedData,
            colors: {
              Premium: '#1EAEFF',
              Advanced: '#80BD4D',
              Basic: '#D87E00',
              Entry: '#E9CA1E',
              CROS: '#1B75BB',
              Unspecified: '#ADB1B9'
            },
            type : 'donut',
            empty: { label: { text: 'No data available' }},
          },
          legend: { show: false, position: 'right' },
          donut: { width: 48 },
        };
      },
      formattedData() {
        const data = {};
        // Create the data object for chart.
        lodash.map(this.mixTierData, (tier) => {
          if (parseInt(tier.units) > 0) {
            let tierName = lodash.capitalize(tier.technology_tier);
            if (tierName.length === 0 || tierName == 'Economy' || tierName == '#N/A') {
              tierName = 'Unspecified';
            } else if (tierName == 'Cros') {
              tierName = 'CROS';
            }
            data[tierName] = parseInt(tier.units);
          }
        })
        return data;
      }
    },
  };
</script>

<style lang="scss" scoped>
.chartColor {
  @include e(box) {
    width: 11px;
    height: 11px;
    border-radius: 100%;
    border: none;

    @include m(Premium) {
        background: $color-tier-premium;
    }

    @include m(Advanced) {
        background: $color-tier-advanced;
    }

    @include m(Basic) {
        background: $color-tier-basic;
    }

    @include m(Entry) {
        background: $color-tier-entry;
    }

    @include m(Economy) {
        background: $color-tier-economy;
    }

    @include m(CROS) {
        background: $color-tier-CROS;
    }

    @include m(Unspecified) {
        background: $bombay;
    }
  }
}

.mix {
  @include e('chart') {
    h3 {
      font-weight: 600;
      font-size: em(20px);
    }
  }
}

.chart {
  @include e('wrapper') {
    padding: 15px 0 15px 30px;
    @include breakpoint($x-small) {
      padding: em(10px) 0 em(10px) 0;
    }
    @include breakpoint($small) {
      padding: em(10px) 0 em(10px) 0;
    }

    h3 {
      font-family: $font-family--secondary;
      color: $east-bay;
      font-size: em(16px);
      margin-bottom: 18px;
    }
  }
}

.pieTable {
  width: 100%;

  @include e('header') {
    color: $dove-grey;
    font-weight: 600;
    font-size: em(14px);

    @include m('value') {
      text-align: right;
    }
  }

  @include e('key') {
    color: $dove-grey;
  }

  .pieTable__value {
    text-align: right;
    color: $dove-grey;
    font-weight: 600;
  }

  tbody {
    border-top: 1px solid $mystic;
  }

  tbody:before {
    content: '';
    display: block;
    height: 5px;
  }

  th {
    font-weight: 500;
    padding-bottom: 5px;
  }

  td {
    text-align: left;
    padding: 4px;
  }

  .chartColor {
    width: 22px;
  }
}
</style>
